import raEnglishMessages from 'ra-language-english'
import merge from 'lodash/merge'
import custom from './custom'
import overrides from './overrides'
import resources from './resources'
import views from './views'

export default merge({}, raEnglishMessages, overrides, custom, resources, views)
